import { createContext } from "react";
import { BSDashboardContextType } from "../../../types/businessSummary";

const BSDashboardContext = createContext<BSDashboardContextType | undefined>(
  undefined
);

export { BSDashboardContext };
